import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Divider,
} from '@mui/material';

import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  
} from '@mui/material';


import { DataGrid, gridClasses, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { lightGreen, red } from '@mui/material/colors';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { toast } from 'react-toastify';

import { useSelector } from 'react-redux';
import { useGetShiftsQuery } from '../slices/shiftApiSlice';
import {
  useGetShiftRequestsByUserIdQuery,
  useCreateShiftRequestMutation,
   useDeleteShiftRequestMutation,
} from '../slices/shiftRequestApiSlice';

import { useLayout } from '../context/LayoutContext';
import { useUpdateShiftRequestStatusAllMutation } from '../slices/shiftRequestApiSlice';

// Styled DataGrid with conditional row styles
const StyledDataGrid = styled(DataGrid)`
  & .${gridClasses.row}.lightGreenRow {
    background-color: ${lightGreen[100]};
  }
  & .${gridClasses.row}.redRow {
    background-color: ${red[100]};
  }
     & .${gridClasses.row}.lightOrangeRow {
    background-color: #ffe0b2; /* Light orange */
  }
  & .${gridClasses.row}.greenRow {
    background-color: #c8e6c9; /* Soft green */
  }

  & .${gridClasses.row}.darkGreenRow {
    background-color:rgb(149, 240, 152); /* Dark green */
  }

`;


//____________________________________________________________________________________________________________________________________
const ShiftRequestScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
const { setFluid } = useLayout();
  const { data: shifts, isLoading: loadingShifts, refetch: refetchShifts } = useGetShiftsQuery();
  const {
    data: shiftRequests,
    refetch,
    isLoading: loadingRequests,
  } = useGetShiftRequestsByUserIdQuery(userInfo._id);
  
const CustomToolbar = () => (
  <div style={{ padding: '0.5rem 1rem' }}>
    <GridToolbarQuickFilter />
  </div>
);

const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [createShiftRequest] = useCreateShiftRequestMutation();
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);
const [updateShiftRequestStatus] = useUpdateShiftRequestStatusAllMutation();
const [reapplyModalOpen, setReapplyModalOpen] = useState(false);
const [cancelledRequestToReapply, setCancelledRequestToReapply] = useState(null);

const [selectedShift, setSelectedShift] = useState(null);
const [filledByAgencyName, setFilledByAgencyName] = useState('');
const [filledByAgencyWorkerContact, setFilledByAgencyWorkerContact] = useState('');

const [isAgencyFilling, setIsAgencyFilling] = useState(userInfo?.isAgency || false);

  const getRowClassName = (params) => {
  const now = new Date();
  const end = new Date(params.row.endDateTime);

  if (end < now) return 'redRow';

  const status = params.row.lineStatus?.toLowerCase();

  switch (status) {
    case 'open':
    case 'on hold':
      return 'lightOrangeRow';

    case 'archived':
    case 'filledbystaff':
    case 'filled':
    case 'complete':
      case 'approved':
      return 'greenRow';

    case 'filledbyagency':
      return 'darkGreenRow';

    case 'cancelled':
      return 'redRow';

    default:
      return 'lightGreenRow';
  }
};

const [confirmModalOpen, setConfirmModalOpen] = useState(false);
const [infoModalOpen, setInfoModalOpen] = useState(false);
const [selectedRequestToCancel, setSelectedRequestToCancel] = useState(null);

{/*
  const handleSelectShift = async (shift) => {
  const existingRequest = shiftRequests?.find(
    (req) => req.shiftId === shift._id
  );

 //console.log("existingRequest", existingRequest);

    


  if (existingRequest) {

    const existingRequestUpdate = {

    startDateTime: shift.startDateTime,
    endDateTime: shift.endDateTime,
    hospitalLocationId: shift.hospitalLocationId,
    wardDepartmentArea: shift.wardDepartmentArea,
    categoryOfStaff: shift.categoryOfStaff,
    requestedBy: userInfo._id,
    requestedByName: userInfo.name,
    requestedByEmail: userInfo.email,
    shiftId: shift._id,
    _id: existingRequest._id,
    lineStatus: 'Open'
  };


    if (existingRequest.lineStatus?.toLowerCase() === 'cancelled') {
      setCancelledRequestToReapply(existingRequestUpdate);
      setReapplyModalOpen(true);
    }
    return; // Don't create a new request if one exists
  }

  const newRequest = {
    startDateTime: shift.startDateTime,
    endDateTime: shift.endDateTime,
    hospitalLocationId: shift.hospitalLocationId,
    wardDepartmentArea: shift.wardDepartmentArea,
    categoryOfStaff: shift.categoryOfStaff,
    requestedBy: userInfo._id,
    requestedByName: userInfo.name,
    requestedByEmail: userInfo.email,
    shiftId: shift._id,
  };

  try {
    await createShiftRequest(newRequest).unwrap();
    refetch();
    refetchShifts();
  } catch (err) {
    console.error(err);
  }
};

*/}

  const handleSelectShift = async (shift) => {
  setSelectedShift(shift);
  
 //console.log("isAgencyFilling ........." , isAgencyFilling)
  const existingRequest = shiftRequests?.find(
    (req) => req.shiftId === shift._id
  );

  if (existingRequest) {
    const existingRequestUpdate = {
      startDateTime: shift.startDateTime,
      endDateTime: shift.endDateTime,
      hospitalLocationId: shift.hospitalLocationId,
      wardDepartmentArea: shift.wardDepartmentArea,
      categoryOfStaff: shift.categoryOfStaff,
      requestedBy: userInfo._id,
      requestedByName: userInfo.name,
      requestedByEmail: userInfo.email,
      shiftId: shift._id,
      _id: existingRequest._id,
      lineStatus: 'Open'
    };

    if (existingRequest.lineStatus?.toLowerCase() === 'cancelled') {
      setCancelledRequestToReapply(existingRequestUpdate);
      setReapplyModalOpen(true);
    }
    return; // Don't create a new request if one exists
  }

  // Use setTimeout to ensure state updates before opening modal
  setTimeout(() => setOpenConfirmModal(true), 0);
};

  const [deleteShiftRequest] = useDeleteShiftRequestMutation();

  const shiftColumns = [
    {
      field: 'select',
      headerName: '',
      width: 60,
      renderCell: (params) => (
        <Checkbox
          checked={selectedShiftIds.includes(params.row._id)}
          onChange={() => {
            handleSelectShift(params.row);
            setSelectedShiftIds([...selectedShiftIds, params.row._id]);
          }}
        />
      ),
    },
    {
      field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
       type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.startDateTime).toLocaleString(),
       valueGetter: (params) => {
    const value = params.row?.startDateTime;
    return value ? new Date(value) : null;
  },
  //valueFormatter: (params) => new Date(params.value).toLocaleString(),
 valueFormatter: (params) => {
    return params.value ? new Date(params.value).toLocaleString() : '';
  },

    },
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
       type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
       valueGetter: (params) => {
    const value = params.row?.endDateTime;
    return value ? new Date(value) : null;
  },
  //valueFormatter: (params) => new Date(params.value).toLocaleString(),
   valueFormatter: (params) => {
    return params.value ? new Date(params.value).toLocaleString() : '';
  },

    },
    { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 180 },
    { field: 'lineStatus', headerName: 'Status', width: 150 },
    { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
  ];

  const requestColumns = [

    {
    field: 'remove',
    headerName: '',
    width: 60,
    renderCell: (params) => (
  <Checkbox
    color="error"
    onChange={() => {
      //const request = params.row;
       const request = { ...params.row }; // ✅ clone the object

      if (request.lineStatus?.toLowerCase() === 'open') {
       request.lineStatus = 'Cancelled';
        setSelectedRequestToCancel(request);
        setConfirmModalOpen(true);
      } else {
        setInfoModalOpen(true);
      }
    }}
  />
),

  },
    {
      field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
      type: 'dateTime',
        valueGetter: (params) => new Date(params.row.startDateTime),
        valueFormatter: (params) => new Date(params.value).toLocaleString(),
},
    
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
      type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
      valueGetter: (params) => new Date(params.row.endDateTime),
  valueFormatter: (params) => new Date(params.value).toLocaleString(),

    },
    { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 180 },
    { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
    { field: 'lineStatus', headerName: 'Status', width: 150 },
  ];


  useEffect(() => {
        // Enable full-width container
        setFluid(true);
    
        return () => {
          // Reset back to normal when screen unmounts
          setFluid(false);
        };
      }, [setFluid]);
    
//<Typography variant="h6" mb={1}>Available Shifts</Typography>
 //___________________________________________________________________________________________________________________________________________     
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" mb={2}>Staff Shift Request Panel..</Typography>
      
     

<Grid container spacing={2}>

        

         <Grid item xs={12} md={6}>
          
          {loadingShifts ? (
            <CircularProgress />
          ) : (

            <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader title="Available Shifts" />
      <CardContent>

      
            <StyledDataGrid
      density="compact"
              rows={shifts?.filter((s) => !s.stage1Approval) || []}
              columns={shiftColumns}
              getRowId={(row) => row._id}
              getRowClassName={getRowClassName}
              autoHeight
              pageSize={10}
               slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
               sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
               
            />
            </CardContent>
    </Card>
          )}

          
        </Grid>

        
        <Grid item xs={12} md={6}>
         
          {loadingRequests ? (
            <CircularProgress />
          ) : (

            <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader title="Your Shift Requests" />
      <CardContent>

      
            <StyledDataGrid
      density="compact"
              rows={shiftRequests || []}
              columns={requestColumns}
              getRowId={(row) => row._id}
              getRowClassName={getRowClassName}
              autoHeight
              pageSize={10}
              slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
              sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
            />

             </CardContent>
    </Card>

          )}
        </Grid>
      </Grid>


      {/* Confirm Cancel Modal */}
<Dialog open={confirmModalOpen} onClose={() => setConfirmModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Cancel Shift Request
    </Typography>
    <Typography>
      Are you sure you want to cancel this shift request?
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
      <Button onClick={() => setConfirmModalOpen(false)}>No</Button>
      <Button
        color="error"
        variant="contained"
        onClick={async () => {
          try {
            
            await updateShiftRequestStatus(selectedRequestToCancel).unwrap();

    //  await updateShiftRequestStatus({
    //shiftRequestId: selectedRequestToCancel._id,
    //update: selectedRequestToCancel,
    //}).unwrap();


            refetch();
            setConfirmModalOpen(false);
          } catch (err) {
            console.error('Failed to cancel shift request:', err);
          }
        }}
      >
        Yes, Cancel
      </Button>
    </Box>
  </Box>
</Dialog>

{/* Info Modal */}
<Dialog open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Cannot Cancel Request
    </Typography>
    <Typography>
      This shift has already been assigned. Please speak to your manager if you need to cancel it.
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button onClick={() => setInfoModalOpen(false)} variant="contained">OK</Button>
    </Box>
  </Box>
</Dialog>

<Dialog open={reapplyModalOpen} onClose={() => setReapplyModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Reapply for Shift
    </Typography>
    <Typography>
      You've previously cancelled this shift. Do you want to reapply?
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
      <Button onClick={() => setReapplyModalOpen(false)}>No</Button>
      <Button
        variant="contained"
        onClick={async () => {
          try {
           //console.log("cancelledRequestToReapply ",cancelledRequestToReapply)
            await updateShiftRequestStatus(cancelledRequestToReapply).unwrap();

            //await updateShiftRequestStatus({
            //shiftRequestId:  cancelledRequestToReapply._id,
            //update: cancelledRequestToReapply,
            //}).unwrap();

            toast.success('Shift request re-applied!');
            refetch();
            refetchShifts();
            setReapplyModalOpen(false);
          } catch (err) {
            console.error('Failed to reapply for shift:', err);
            toast.error('Error reapplying for shift');
          }
        }}
      >
        Yes, Reapply
      </Button>
    </Box>
  </Box>
</Dialog>



{/* get agency details  Modal _____________________________________________________________________________________________________________________________*/}
{/* Confirm Assignment Modal */}
<Dialog
  open={openConfirmModal}
  onClose={() => {
    setOpenConfirmModal(false);
    setSelectedShift(null);
    setFilledByAgencyName('');
    setFilledByAgencyWorkerContact('');
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Confirm Shift Assignment</DialogTitle>
  <DialogContent>
    {selectedShift ? (
      <Box>
        <Typography variant="subtitle1" gutterBottom><strong>Shift Details</strong></Typography>
        <Typography>Location: {selectedShift.hospitalLocationId?.name}</Typography>
        <Typography>Ward: {selectedShift.wardDepartmentArea}</Typography>
        <Typography>Start: {new Date(selectedShift.startDateTime).toLocaleString()}</Typography>
        <Typography>End: {new Date(selectedShift.endDateTime).toLocaleString()}</Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" gutterBottom>
          <strong>{isAgencyFilling ? 'Agency' : 'Staff'} Details</strong>
        </Typography>

        {isAgencyFilling ? (
          <>
            <Typography>Name: {userInfo.name}</Typography>
            <Typography>Email: {userInfo.email}</Typography>

            <TextField
              fullWidth
              required
              label="Agency Worker Name"
              value={filledByAgencyName}
              onChange={(e) => setFilledByAgencyName(e.target.value)}
              margin="normal"
              error={isAgencyFilling && !filledByAgencyName}
              helperText={isAgencyFilling && !filledByAgencyName ? "This field is required" : ""}
            />
            <TextField
              fullWidth
              required
              label="Agency Worker Contact"
              value={filledByAgencyWorkerContact}
              onChange={(e) => setFilledByAgencyWorkerContact(e.target.value)}
              margin="normal"
              error={isAgencyFilling && !filledByAgencyWorkerContact}
              helperText={isAgencyFilling && !filledByAgencyWorkerContact ? "This field is required" : ""}
            />
          </>
        ) : (
          <>
            <Typography>Name: {userInfo.name}</Typography>
            <Typography>Email: {userInfo.email}</Typography>
          </>
        )}
      </Box>
    ) : (
      // ✅ fallback while selectedShift is not yet ready
      <Typography>Loading shift details...</Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenConfirmModal(false)}>Cancel</Button>
    <Button
      onClick={async () => {
        if (isAgencyFilling && (!filledByAgencyName || !filledByAgencyWorkerContact)) {
          toast.error("Please fill all agency fields");
          return;
        }

        try {
          const requestData = {
            startDateTime: selectedShift.startDateTime,
            endDateTime: selectedShift.endDateTime,
            hospitalLocationId: selectedShift.hospitalLocationId,
            wardDepartmentArea: selectedShift.wardDepartmentArea,
            categoryOfStaff: selectedShift.categoryOfStaff,
            requestedBy: userInfo._id,
            requestedByName: userInfo.name,
            requestedByEmail: userInfo.email,
            shiftId: selectedShift._id,
            ...(isAgencyFilling && {
              filledByAgencyName,
              filledByAgencyWorkerContact,
              lineStatus: 'FilledByAgency',
            }),
          };

          await createShiftRequest(requestData).unwrap();
          toast.success("Shift request created successfully!");
          refetch();
          refetchShifts();
          setOpenConfirmModal(false);
          setFilledByAgencyName('');
          setFilledByAgencyWorkerContact('');
        } catch (err) {
          console.error(err);
          toast.error(err.data?.message || "Failed to create shift request");
        }
      }}
      color="primary"
      variant="contained"
    >
      Confirm Assignment
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default ShiftRequestScreen;
